export enum MilestoneType {
    goalieGamesPlayed = 'goalieGamesPlayed',
    goalieWins = 'goalieWins',
    goalieShutouts = 'goalieShutouts',
    goalieMinutesPlayed = 'goalieMinutesPlayed',
    skaterGamesPlayed = 'skaterGamesPlayed',
    skaterGoals = 'skaterGoals',
    skaterAssists = 'skaterAssists',
    skaterPoints = 'skaterPoints',
}
